import {Link} from "react-router";
import {useContext} from "react";
import { ReactSVG } from 'react-svg';
import {DndContext} from '@dnd-kit/core';

import GeneralContext from "../contexts/Gneral.tsx";
import ActivityContext from "../contexts/Activity.tsx";
import {ActivityItem} from "../components/ActivityItem.tsx";
import {PersonArea} from "../components/PersonArea.tsx";
import {useNavigate} from "react-router";

export function RateActivity () {
    // @ts-ignore
    const  {activities,contents}  = useContext(GeneralContext);
    const  {avatar , currentActivity, nextActivity, currentActivityResolved, moveToResolved}  = useContext(ActivityContext);
    const Activity = activities[currentActivity];
    let navigate = useNavigate();
    return (<div  className={'builder-screen'}>
        <DndContext>
            <div className={'selectingAside'}>
                <div className={'aside-content'}>
                    <h1>{contents.rateActivityScreenHeading}</h1>
                    { !Activity.editable ?
                        <p>{contents.rateActivityScreenContent1}</p>
                        :
                        <p>{contents.rateActivityScreenContent2}<br />{contents.rateActivityScreenContent3}</p>
                    }
                </div>
                <ActivityItem Activity={Activity} />
                <div className={"activities-nav"}>
                    <div className={"counter"}>
                        <span>{(currentActivity + 1).toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })}</span> / {activities.length}
                    </div>
                    <button disabled={!currentActivityResolved} onClick={() => {
                        (activities.length == currentActivity + 1) && navigate('/confirm-activity')
                        nextActivity();
                    }} className={"btn next"}>Next</button>
                </div>
            </div>
            <div className={'visualArea'}>
            <PersonArea Activity={Activity} />
        </div>
        </DndContext>
    </div>);
}